import { useAuthContext } from '@/contexts/AuthContext';

/** Route-safe domain hook for the active authentication session. */
export const useAuth = useAuthContext;
